import React from 'react';
import {View, StyleSheet} from 'react-native';
import {onboardingColors} from '../theme/onboardingColors';

const StepIndicator = ({currentStep, totalSteps = 5}) => {
  return (
    <View style={styles.container}>
      {Array.from({length: totalSteps}, (_, index) => (
        <View
          key={index}
          style={[
            styles.dot,
            index === currentStep - 1 ? styles.dotActive : null,
          ]}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 16,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: onboardingColors.dot,
    marginHorizontal: 4,
  },
  dotActive: {
    width: 24,
    backgroundColor: onboardingColors.dotActive,
    borderRadius: 4,
  },
});

export default StepIndicator;
